export const APP_VESION = "283835c";
export const CMS_API_URL = "https://cms.ihopa.com";
export const ENV = "prod";

let iamApiUrl = "https://2sva6sdzv7.execute-api.eu-central-1.amazonaws.com/stage";
// let circlesApiUrl = "https://g85wscbgc1.execute-api.eu-central-1.amazonaws.com/stage";
let circlesApiUrl = "https://ttxrb279mk.execute-api.eu-central-1.amazonaws.com/stage";

let messagingApiUrl = "https://k2klk72p7j.execute-api.eu-central-1.amazonaws.com/stage";
let notificationsApiUrl = "https://y8gitvvlkc.execute-api.eu-central-1.amazonaws.com/stage";
let site_url = "http://localhost:3000";
if (ENV === "prod") {
  iamApiUrl = "https://29nhs63i78.execute-api.eu-central-1.amazonaws.com/prod";
  circlesApiUrl = "https://4l7a6h2rk8.execute-api.eu-central-1.amazonaws.com/prod";
  messagingApiUrl = "https://ah0x2zao7k.execute-api.eu-central-1.amazonaws.com/prod";
  notificationsApiUrl = "https://j7p3g5vtab.execute-api.eu-central-1.amazonaws.com/prod";
  site_url = "https://app.ihopa.com";
}

export const THANK_YOU_PAGE = "https://ihopa.com/thank-you";
export const RENTAL_THANK_YOU_PAGE = `${site_url}/rental-success`;

export const INTERCOM_APP_ID = "hhso1e3s";
export const IAM_API_URL = iamApiUrl;
export const CIRCLES_API = circlesApiUrl;
export const MESSAGING_API_URL = messagingApiUrl;
export const NOTIFICATAIONS_API_URL = notificationsApiUrl;
export const SITE_URL = site_url;

export const USER_IMAGE_URL = "https://dvqqznzpq0sjw.cloudfront.net/";
export const CIRCLE_IMAGE_URL = "https://d2y5favn0qvt0u.cloudfront.net/";
export const CIRCLE_ADS_IMAGE_URL = "https://dmd2zpyb1yryy.cloudfront.net/";

export const GOOGLE_API_KEY = "AIzaSyA-s-66SQoeoBZiGyH4hFUR-gq76P1qal4";

export const NO_USER_PHOTO_URL = "https://s3.eu-central-1.amazonaws.com/ihopa-user-images/no_image.png";
export const PRODUCT_IMAGE_BASE_URL = "https://s3.eu-central-1.amazonaws.com/ihopa-product-images";

export const HOME_CATEGORIES_ORDER = ["all", "boats", "leisure", "garden", "watersport", "husqvarna", "other"];

export const OLD_BOOKINGS_END_TIME = 1594771200000; //has to have 13 digits

export const SHARING_BOX_URL_PIECES = {
  url: "https://api.cosmicjs.com/v1/ihopa-production/object/",
  query:
    "?pretty=true&hide_metafields=true&read_key=7SGJ5Ov3C5rauYlTQnLEWcUiFsCDdaIODWEV36NQVIfIgA3LbQ&props=slug,title,content,metadata",
};

const DEV_STRIPE_KEY = "pk_test_YkiMCveFyVprkapCTNg5pfMm00DYwz0Om2";
export const STRIPE_KEY = "pk_live_uTO5DwQcF4exY2d38d3kRS2v00yTvITNQj";
export const MAX_RENTAL_INTERVAL = 48 //hours;
